import { StructureService } from '../../../services/structure_service';
import { lazyInject } from '../../../services/inversify';


const stateChanged = 1;
const stateNew = 2;
const stateMissing = 3;
const stateUnchanged = 4;
const stateInvalid = 5;
const stateTypeFehler = 6;
const stateDoppelt = 7;
export const stateChangedOrig = 8;


export class DiffTool {



    constructor(module: string) {
        this.module = module;
    }
    private module: string;
    private debug = false;

    @lazyInject(StructureService) private structureService: StructureService;



    public mergeData(structureKey: string, dataBase: Array<any>, dataDiff: Array<any> , setDiffProgress?: (percent: number) => void) {
        if (this.debug) {
            console.log('DataDiff', dataDiff);
            console.log('DataBase', dataBase);
        }
        // console.log(new Date() + ': diff start');
        const dataBaseMap: any = {};
        const dataProcessedMap: any = {};
        const resultData: Array<any> = [];
        const dataProcessed: Array<any> = [];   // Hier landen alle bereits verarbeiteten Import-Datensätze

        const structure: any = this.structureService.getStructureByKey(this.module, structureKey);
        // Zunächst die Keys ermitteln
        const keys: Array<string> = [];
        const fields: Array<string> = [];
        const types: Array<any> = [];

        const atts = structure.ATTS;
        atts.forEach((att: any) =>  {
            if (att.REQUIRED && att.REQUIRED.toString().toLowerCase() === 'key') {
                keys.push(att.KEY); // KEYS
                if (att.OPTS) {
                    types.push('REF');
                } else {
                    types.push(this.getTypesName(att.TYPE, att.KEY));
                }
            } else {
                fields.push(att.KEY); // NICHT-KEYS
                if (att.OPTS) {
                    types.push({type: 'REF', length: '', name: att.KEY });
                } else {
                    types.push(this.getTypesName(att.TYPE, att.KEY));
                }
            }
        });
        // KeyStrings (Quasi-Hashes) für alle Rows aus den Basis-Daten erzeugen
        dataBase.forEach((row) => {
            const keyString = this.getKeyString(keys, row);
            dataBaseMap[keyString] = row;
        });
        // console.log(keys);
        // alert('keys');
        // Jetzt über alle Zeilen der "neuen" Daten gehen
        const total = dataDiff.length;
        let count = 0;
        let percent = 0;
        dataDiff.forEach((row, idx) => {
            const rowIsValid = this.rowIsValid(row, keys);
            // console.log('Checking row');
            // console.log(row);
            count ++;
            const perc = Math.round(100 / total * count);
            if (perc !== percent) {
                percent = perc;
                if (setDiffProgress) {
                    setDiffProgress(perc);
                }
            }
            if (!rowIsValid) {
                // console.log(' ---> invalid');
                row.internal = {};
                row.internal._diffState = stateInvalid;
                resultData.push(row);
                return;
            }
            if (this.debug) {
                console.log(row);
            }
            const rowTypeIsValid = this.rowTypeIsValid(row, types);
            if (!rowTypeIsValid) {
                // console.log(' ---> type invalid');
                row.internal = {};
                row.internal._diffState = stateTypeFehler;
                resultData.push(row);
                return;
            }
            const foundProcessed = this.getDiffRow(dataProcessedMap, row, keys, fields, true);
            // Prüfen, ob wir diesen Datensatz im Import schonmal hatten (--> muss dann schon in dataProcessed stehen)
            if (foundProcessed) {
                // Ist schon in den Import-Daten doppelt
                row.internal = {};
                row.internal._diffState = stateDoppelt;
                resultData.push(row);
            } else {
                const foundRow = this.getDiffRow(dataBaseMap, row, keys, fields, false);
                if (foundRow) {
                    if (this.debug) {
                        console.log(' ---> Found');
                    }
                    resultData.push(foundRow);
                    if (foundRow.internal._origRow) { // Die originale Zeile mit einfügen
                        resultData.push(foundRow.internal._origRow);
                        delete(foundRow.internal._origRow);
                    }
                } else {
                    if (this.debug) {
                        console.log(' ---> New');
                    }
                    row.internal = {};
                    row.internal._diffState = stateNew;
                    resultData.push(row);
                }
            }
            dataProcessed.push(row);
            const keyString = this.getKeyString(keys, row);
            dataProcessedMap[keyString] = row;
        });
        // Alle noch nicht angetroffenen Rows aus den Basisdaten als "fehlend" ins Result eintragen
        dataBase.forEach((row) => {
            if (!row.internal) {
                row.internal = {};
                row.internal._diffState = stateMissing;
                resultData.push(row);
            }
        });
        return resultData;
    }
    private rowIsValid(item: any, keys: Array<string>) {
        let valid = true;
        keys.forEach((k) => {
            // console.log('KEYCHECK: ' + k + ' > ' + item[k]);
            if (item[k] === undefined || item[k] === '' || item === null) {
                valid = false;
            }
        });
        return valid;
    }

    private rowTypeIsValid(item: any, types: Array<any>) {
        let valid = true;
       // console.log(item);
       // console.log(types);
        for ( let i = 0; i < types.length; i++) {
            if (types[i].type === 'REF') {
                // Erstmal nicht checken
            } else
            if (types[i].type === 'number' && item[types[i].name] !== undefined && (item[types[i].name] || '') !== 'undefined') {
                if (typeof item[types[i].name] !== 'number') {
                        if (isNaN(+item[types[i].name])) {
                            if (this.debug) {
                                console.log(item[types[i].name] + ' should be number but is not (' + typeof item[types[i].name] + ')!');
                            }
                            valid = false;
                        }
                }
            } else {
                const itemToString =  item[types[i].name];
                if (itemToString !== undefined && itemToString !== null && (itemToString || '') !== 'undefined') {
                    if (itemToString.toString().length > types[i].length) {
                        if (this.debug) {
                            console.log(item[types[i].name] + ' is a string, but too long!');
                        }
                        valid = false;
                    }
                }
            }
        }
        return valid;
    }
    private getTypesName(types: any, name: any) {
        const typeArray: any = {};
                if (types.includes('CHAR')) {
                    typeArray.type = 'all';
                    typeArray.length = types.slice(4);
                } else if (types === 'TEXT' || types === 'MAIL') {
                    typeArray.type = 'all';
                    if ( types === 'MAIL') {
                        typeArray.length = 191;
                    } else if (types === 'TEXT') {
                        typeArray.length = 65535;
                    }
                } else {
                    typeArray.type = 'number';
                    typeArray.length = '';
                }
                typeArray.name = name;
        return typeArray;
    }
    private getKeyString(keys: Array<string>, item: any) {
        let keyString = '';
        keys.forEach((k) => {
            keyString += item[k] + '__';
        });
        return keyString;
    }
    private getDiffRow(dataBaseMap: any, item: any, keys: Array<string>, fields: Array<string>, justCheck: boolean) {
       const keyString = this.getKeyString(keys, item);
       const found = dataBaseMap[keyString];
        if (found) {    // Eine Zeile mit dem gleichen Key wurde gefunden
            const found_orig = {...found}; // Die Original-Row als Variable merken
            // Gefunden
            let missmatch = false;
            fields.forEach((k) => {
                let item_val = item[k];
                let found_val = found[k];
                if (item_val === null || item_val === '' ) {
                    item_val = 0;
                }
                if (found_val === null || found_val === '' ) {
                    found_val = 0;
                }
                if ((item_val + '' !== found_val + '') && item_val !== undefined) { // Nur String-Vergleich
                    // console.log(k + ': ' + item_val + ' missmatches ' + found_val);
                    if (!justCheck) {   // Daten in Datenbasis mit denen aus dem neuen Item überschreiben
                        found[k] = item[k];
                    }
                    missmatch = true;
                }
            });
            if (!justCheck) {
                found.internal = {};
                found_orig.internal = {};
                if (missmatch) {
                    if (this.debug) {
                        console.log('changed');
                        console.log(item);
                        console.log(found);
                    }
                    found.internal._diffState = stateChanged;
                    found_orig.internal._diffState = stateChangedOrig;
                    found.internal._origRow = found_orig;
                } else {
                    if (this.debug) {
                        console.log('unchanged');
                    }
                    found.internal._diffState = stateUnchanged;
                }
            }
            return found;
        }
    }
    public static getDiffStyle(state: number) {
       // console.log(state);
        switch (state) {
            case stateChanged:
                return {background: '#FFFF99'};
            case stateNew:
                return {background: '#AAAAFF'};
            case stateMissing:
                return {background: '#FFAAAA'};
            case stateUnchanged:
                return {background: '#CCFFCC'};
            case stateInvalid:
                return {background: '#880000', color: '#CCAAAA'};
            case stateTypeFehler:
                return {background: '#FFFFFF', color: '#880000'};
            case stateDoppelt:
                return {background: '#444444', color: '#AAAAAA'};
            case stateChangedOrig:
                return {background: '#FFEECC', color: '#FF8888'};
        }
        return {};
    }
    public static shouldSave (item: any) {
        return  item.internal._diffState === stateChanged || item.internal._diffState === stateNew;
    }

    public static errorRow (item: any) {
        return item.internal._diffState === stateInvalid || item.internal._diffState === stateTypeFehler;
    }
}
